import * as Bowser from "bowser";
import { private_sign } from "./sign";
import { private_verify } from "./verify";
import { VerificationPerformanceResults } from "./worker-interface";

let signedFile: File | null = null;

// @ts-ignore
window.remove_elements = function remove_elements(evt: string | undefined = undefined) {
  // ...
  const bodyChildren = document.body.children;
  const elementsArray = Array.from(bodyChildren);
  elementsArray.forEach((element) => {
    // Manter elementos com tags específicas OU com classes específicas
    if (element.tagName !== "H1" &&
      element.tagName !== "FORM" &&
      element.tagName !== "A" &&
      !element.classList.contains('preserve-element')) {
      element.remove();
    }
  });
};

// @ts-ignore
window.verify_files = async function verify_files(event: any, urls: string[]) {
  event.preventDefault();

  // @ts-ignore
  window.remove_elements();
  const browser = Bowser.getParser(navigator.userAgent);

  // @ts-ignore
  const files: FileList = signedFile ? ([signedFile] as FileList) : document.getElementById("fileInput").files;

  const perf: VerificationPerformanceResults = {
    tsls: {
      name: "TSLs",
      value: 0,
    },
    parserPdf: {
      name: "ParserPdf",
      value: 0,
    },
    docHash: {
      name: "DocHash",
      value: 0,
    },
    cmsVerification: {
      name: "cmsVerification_time",
      value: 0,
    },
    docIntegrity: {
      name: "DocIntegrity",
      value: 0,
    },
    cmsParsing: {
      name: "cmsParsing_time",
      value: 0,
    },
    byteRange: {
      name: "ByteRange",
      value: 0,
    },
    crls: {
      name: "CRLs",
      value: 0,
    },
    reportCreation: {
      name: "reportCreation_time",
      value: 0,
    },
    trustedChain: {
      name: "TrustedChain",
      value: 0,
    },
    verifyCertAu: {
      name: "VerifyCertAu",
      value: 0,
    },
    total: {
      name: "total_time",
      value: 0,
    },
  };
  const [result, perfFinal] = await private_verify(files, urls, perf);

  console.log(perfFinal);

  if (result.length === 0) {
    const errorContainer = document.createElement("div");
    errorContainer.className = "alert alert-warning";
    errorContainer.innerHTML = `
      <h4 class="alert-heading">Documento sem assinaturas</h4>
      <p>Este documento não possui assinaturas digitais.</p>
    `;
    document.body.appendChild(errorContainer);
    return;
  }

  const perf_info = {
    // @ts-ignore
    ...Object.fromEntries(
      Object.entries(perfFinal)
        // @ts-ignore
        .filter(([k, v]) => v.name !== undefined)
        // @ts-ignore
        .map(([k, v]) => [v.name, v.value])
    ),
    user_agent: navigator.userAgent,
    filename: files[0].name,
    file_size: files[0].size / 1024,
    browser: browser.getBrowserName(),
    browser_version: browser.getBrowserVersion(),
    os: browser.getOSName(),
    os_version: browser.getOSVersion(),
    platform: browser.getPlatformType(),
    num_signatures: result.length,
  };
  console.log(perf_info);

  // Formatar os resultados para serem exibidos na interface
  // Isso será processado pelo código HTML/JS na página de verificação
  const verificationResults = document.createElement("div");
  verificationResults.id = "verification-results";
  verificationResults.dataset.results = JSON.stringify(result);
  verificationResults.style.display = "none"; // Esconder o elemento, apenas armazenar os dados
  document.body.appendChild(verificationResults);

  // Criamos um evento personalizado para notificar que os resultados estão disponíveis
  const verificationCompleteEvent = new CustomEvent("verification-complete", {
    detail: {
      results: result,
      performanceInfo: perf_info
    }
  });
  document.dispatchEvent(verificationCompleteEvent);

  // NOTA: Comentado o código antigo que criava elementos HTML diretamente
  // Agora, a UI será criada pelo código HTML/JS na página de verificação
  /*
  let ol = document.createElement("ol");
  document.body.appendChild(ol);
  for (let i = 0; i < result.length; ++i) {
    // react? angular? jquery? never heard of them.
    let li = document.createElement("li");
    let div = document.createElement("div");
    let p = document.createElement("p");
    p.textContent = `Assinatura ${i + 1}:`;
    div.appendChild(p);
    ol.appendChild(li);
    li.appendChild(div);

    div.innerHTML =
      div.innerHTML +
      "\n" +
      `Certificado:\n` +
      // Resto do código comentado...
  }
  */
};

// @ts-ignore
window.sign_files = async function sign_files(event: any) {
  event.preventDefault();

  // @ts-ignore
  window.remove_elements();

  const browser = Bowser.getParser(navigator.userAgent);

  // @ts-ignore
  const files: FileList = signedFile ? ([signedFile] as FileList) : document.getElementById("fileInput").files;
  const selectedFile = files[0];

  let success = true;
  let perf: any = {},
    pkcs7 = null,
    privateKey = null,
    signature_count = null;
  try {
    const result = await private_sign(files, undefined, 2048);
    signedFile = result.signedFile as File;
    perf = result.perf;
    privateKey = result.privateKey;
    pkcs7 = result.pkcs7;
    signature_count = result.signature_count;
  } catch (error) {
    success = false;
    console.error("Erro durante a assinatura: %s", error);
    document.createElement("p").textContent = `Erro ao assinar arquivo ${selectedFile.name} --> ${error}`;
  }

  const perf_info = {
    // @ts-ignore
    ...Object.fromEntries(
      Object.entries(perf)
        // @ts-ignore
        .filter(([k, v]) => v.name !== undefined)
        // @ts-ignore
        .map(([k, v]) => [`${k}_time`, v.value])
    ),
    user_agent: navigator.userAgent,
    client_success: success.toString(),
    filename: `${selectedFile.name.replace(".pdf", "")}_assinado.pdf`,
    file_size: selectedFile.size / 1024,
    browser: browser.getBrowserName(),
    browser_version: browser.getBrowserVersion(),
    num_signatures: signature_count,
    os: browser.getOSName(),
    os_version: browser.getOSVersion(),
    platform: browser.getPlatformType(),
    original_hash: await selectedFile
      .arrayBuffer()
      .then((buf) => window.crypto.subtle.digest("SHA-256", buf))
      .then((hash) =>
        Array.from(new Uint8Array(hash))
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("")
      ),
  };

  console.log(perf_info);
  // NOTE: we are only sending the document here for testing purposes. This would never be done in
  //       production code.
  //const form = new FormData();
  //form.append("file", selectedFile, selectedFile.name);
  //form.append("pkcs7", pkcs7);
  //form.append("private_key", privateKey);
  //form.append("performance_info", JSON.stringify(perf_info));
  ////
  //fetch("/api/v1/insert-signature-results", {
  //  method: "POST",
  //  body: form,
  //});
  //

  if (success) {
    const downloadButton = document.createElement("button");
    downloadButton.textContent = "Salvar arquivo assinado";
    downloadButton.id = "downloadBtn";
    document.body.appendChild(downloadButton);
    downloadButton.addEventListener("click", () => {
      const downloadAnchor = document.createElement("a");
      const url = URL.createObjectURL(signedFile);
      downloadAnchor.href = url;
      downloadAnchor.download = signedFile.name;
      downloadAnchor.click();
    });
  }
};
